var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProviders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.5L18.5 7V8.5H1.5V7L10 1.5ZM3 10H5.5V16H3V10ZM8.75 10H11.25V16H8.75V10ZM14.5 10H17V16H14.5V10ZM1.5 17H18.5V18.5H1.5V17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviders);
export default __webpack_public_path__ + "static/media/providers.fcb3d40fbf6290084d78ef97b7b5b4a9.svg";
export { ForwardRef as ReactComponent };